/**
 * NuGuard AI - Badge UI Component
 * 
 * Small badge for displaying status, counts, or labels.
 */

import React from 'react';
import { cn } from '../../lib/utils';

type BadgeVariant = 'default' | 'primary' | 'success' | 'warning' | 'danger' | 'info';

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** Visual style variant */
  variant?: BadgeVariant;
  /** Make badge smaller */
  small?: boolean;
}

const variantClasses: Record<BadgeVariant, string> = {
  default: 'ng-badge-default',
  primary: 'ng-badge-primary',
  success: 'ng-badge-success',
  warning: 'ng-badge-warning',
  danger: 'ng-badge-danger',
  info: 'ng-badge-info',
};

export const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'default',
  small = false,
  className,
  ...props
}) => {
  return (
    <span
      className={cn(
        "ng-badge-base",
        small ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-1 text-xs",
        variantClasses[variant],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
};
